<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <ng-container>
        <div style="padding: 15px; margin: 5px; width: -webkit-fill-available;">
            <div class="main-heading">
                <h1>Subscriber Email Dashboard</h1>
            </div>

            <div class="dropdown" style="margin: 10px 0;">
                <p-calendar [(ngModel)]="date" dateFormat="dd-mm-yy" [showIcon]="true" placeholder="Select Date"
                    (ngModelChange)="onDateChange($event)"></p-calendar>
            </div>

            <div class="container-fluid">
                <!-- Counts Table -->
                <div class="table-container" *ngIf="counts?.length > 0">
                    <div class="flex" style="display: flex; justify-content: flex-end; gap: 10px;">
                        <button class="btn btn-primary" (click)="toggleEditMode()">
                            {{ isEditing ? 'Save' : 'Edit' }}
                        </button>

                        <button class="btn btn-primary" (click)="ViewMailTemplate()">
                            View Template
                        </button>
                    </div>
                    <h2 style="color: green;">Summary:</h2>
                    <table class="table table-bordered">
                        <tbody>
                            <tr *ngFor="let item of counts; let i = index">
                                <td *ngIf="!isEditing">{{ item.type }}</td>
                                <td *ngIf="isEditing">
                                    <input type="text" [(ngModel)]="counts[i].type" class="form-control" />
                                </td>
                                <td *ngIf="!isEditing">{{ item.count }}</td>
                                <td *ngIf="isEditing">
                                    <input type="number" [(ngModel)]="counts[i].count" class="form-control" />
                                </td>
                                <!-- <td *ngIf="isEditing">
                                    <button class="btn btn-danger btn-sm" (click)="deleteRow(counts, i)">Delete</button>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                    <!-- <button class="btn btn-success" *ngIf="isEditing" (click)="addRow(counts, ['type', 'count'])">
                        Add Row
                    </button> -->
                </div>


                <!-- Approved ANDA Table -->
                <!-- <div class="table-container" *ngIf="approvedANDAData?.length > 0">
                    <h2>Approved ANDA:</h2>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th *ngFor="let header of approvedANDAHeaders">{{ header }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of approvedANDAData; let i = index">
                                <td *ngFor="let header of approvedANDAHeaders">
                                    <span *ngIf="!isEditing">{{ row[header] }}</span>
                                    <input *ngIf="isEditing" [(ngModel)]="approvedANDAData[i][header]"
                                        class="form-control" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div> -->

                <div class="table-container" *ngIf="approvedANDAData?.length > 0">
                    <h2>Approved ANDA:</h2>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th *ngFor="let header of approvedANDAHeaders">{{ header }}</th>
                                <th *ngIf="isEditing">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of approvedANDAData; let i = index">
                                <td *ngFor="let header of approvedANDAHeaders">
                                    <span *ngIf="!isEditing">{{ row[header] }}</span>
                                    <input *ngIf="isEditing" [(ngModel)]="approvedANDAData[i][header]"
                                        class="form-control" />
                                </td>
                                <td *ngIf="isEditing">
                                    <button class="btn btn-warning btn-sm mb-2"
                                        (click)="addRow(approvedANDAData, approvedANDAHeaders, row)">Duplicate</button>
                                    <button class="btn btn-danger btn-sm"
                                        (click)="deleteRow(approvedANDAData, i)">Delete</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <button class="btn btn-success" *ngIf="isEditing"
                        (click)="addRow(approvedANDAData, approvedANDAHeaders)">
                        Add Row
                    </button>
                </div>


                <!-- Approved ANDA Summary -->
                <div class="summary-container" *ngIf="approvedANDASummary?.length > 0">
                    <h2>Approved ANDA:</h2>
                    <div class="editor-content" style="margin-bottom: 10px;"
                        *ngFor="let summary of approvedANDASummary; let i = index">
                        <p *ngIf="!isEditing" [innerHTML]="sanitizeHtml(summary)"></p>
                        <ckeditor *ngIf="isEditing"  [editor]="Editor"  (ready)="onEditorReady($event, i)" [ngModel]="approvedANDASummary[i]"
                            >
                        </ckeditor>
                        <button *ngIf="isEditing" class="btn btn-danger btn-sm"
                                        (click)="deleteRowArroved(summary, i)">Delete</button>
                    </div>
                    <button type="button" class="btn btn-primary" (click)="addNewApprovedSummary()">Add New
                        Row</button>
                </div>

                <!-- Tentative ANDA Table -->
                <!-- <div class="table-container" *ngIf="tentativeANDAData?.length > 0">
                    <h2>Tentative ANDA:</h2>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th *ngFor="let header of tentativeANDAHeaders">{{ header }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of tentativeANDAData; let i = index">
                                <td *ngFor="let header of tentativeANDAHeaders">
                                    <span *ngIf="!isEditing">{{ row[header] }}</span>
                                    <input *ngIf="isEditing" [(ngModel)]="tentativeANDAData[i][header]"
                                        class="form-control" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div> -->

                <div class="table-container" *ngIf="tentativeANDAData?.length > 0">
                    <h2>Tentative ANDA:</h2>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th *ngFor="let header of tentativeANDAHeaders">{{ header }}</th>
                                <th *ngIf="isEditing">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of tentativeANDAData; let i = index">
                                <td *ngFor="let header of tentativeANDAHeaders">
                                    <span *ngIf="!isEditing">{{ row[header] }}</span>
                                    <input *ngIf="isEditing" [(ngModel)]="tentativeANDAData[i][header]"
                                        class="form-control" />
                                </td>
                                <td *ngIf="isEditing">
                                    <button class="btn btn-warning btn-sm mb-2"
                                        (click)="addRow(tentativeANDAData, tentativeANDAHeaders, row)">Duplicate</button>
                                    <button class="btn btn-danger btn-sm"
                                        (click)="deleteRow(tentativeANDAData, i)">Delete</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <button class="btn btn-success" *ngIf="isEditing"
                        (click)="addRow(tentativeANDAData, tentativeANDAHeaders)">
                        Add Row
                    </button>
                </div>


                <!-- Tentative ANDA Summary -->
                <div class="summary-container" *ngIf="tentativeANDASummary?.length > 0">
                    <h2>Tentative ANDA:</h2>
                    <div class="editor-content" style="margin-bottom: 10px;"
                        *ngFor="let summary of tentativeANDASummary; let i = index">
                        <p *ngIf="!isEditing" [innerHTML]="sanitizeHtml(summary)"></p>
                        <ckeditor *ngIf="isEditing" [editor]="Editotentativer" [ngModel]="tentativeANDASummary[i]"
                             (ready)="onEditorReadytativer($event, i)">
                        </ckeditor>
                        <button *ngIf="isEditing" class="btn btn-danger btn-sm"
                        (click)="tentativeRowArroved(summary, i)">Delete</button>
                    </div>
                    <button type="button" class="btn btn-primary" (click)="addNewTentativeSummary()">Add New
                        Row</button>
                        
                </div>
            </div>
        </div>
    </ng-container>
    <p-dialog [(visible)]="isDialogVisible" [modal]="true" [header]="'Email Template'" [closable]="true"
        [dismissableMask]="true" [style]="{ width: '50vw' }">
        <div class="p-dialog-content">
            <!-- <pre>{{ subscriberMail }}</pre> -->
            <p [innerHTML]="sanitizeHtml(subscriberMail)"></p>
        </div>
        <p-footer>
            <button type="button" class="btn btn-success" (click)="SendMailTemplate()">
                Send Mail
            </button>
            <button type="button" class="btn btn-secondary" (click)="isDialogVisible = false">
                Close
            </button>
        </p-footer>
    </p-dialog>
</div>